<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" epub:type="dedication" id="dedication" role="doc-dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content"><i>This book is dedicated to Jackie and Lisa, two of my closest friends, whose love and support is never hindered by time or distance.</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1dfb5e1c